import React, { useEffect } from "react";

import { useParams } from "react-router-dom";
import JobPostDetails from "./components/JobPostDetails";

const ViewJobPost = () => {
  const { postId } = useParams(); 
   
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <JobPostDetails recordId={postId}/>
    </div>
  );
};


export default ViewJobPost;
